<div class="flex flex-column align-items-center text-center" data-cy="page-error">
  <img src="./assets/icons/divisional-icons/bandaid-blue.svg" height="92px" class="mb-5" alt="Error Icon" />
  <h1 class="mt-0 mb-5 error-title">Activation link has already been used</h1>
  <p class="p2 mt-0 mb-4 error-message">
    Your account is all set up! Click Sign In below and use your credentials to log in.
  </p>
  <button
    pButton
    type="submit"
    label="Sign In"
    class="w-full"
    (click)="backToSignIn()"
    data-cy="submit-button"
  ></button>
</div>
<app-mobile-footer></app-mobile-footer>
